<template lang="pug">
v-dialog(v-model='dialog' max-width="1700px" @click:outside='closeDialog()')
  v-card
    v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
      v-spacer
      v-btn#closeIcon(icon color='white' @click='closeDialog')
        md-icon close
    .md-layout
      .md-layout-item.md-size-100.mx-auto(style='padding: 0')
        DataProvider(:timezone='true' :endpoint='endpoint', :filter='filter' :key="componentKey" ref='dataProvider')
          div(slot-scope='{ data: response, error, loading }')
            DataTable(
              v-if='response && response.data'
              :data='response && response.data'
              ref='dataTable'
              :title="$t('campaign.listOfTriggeredTriggers')"
              :customTotal='(response && response.total) || 0'
              @pagination='handlePagination'
              :currentSort.sync='filter.orderBy',
              :currentSortOrder.sync='filter.order',
              :selectable='false'
              :loading='loading'
              customHeader
              :endpoint='endpoint'
              :labels='labels'
              :filter='filter'
              :formatLabelFunction='formatLabels'
              csvComponentId="csv-notification-status"
              fileName='notificacoes_efetuadas'
              orientationPDF="landscape"
              :createHeader='createHeaderPDF')
              template(slot="custom-filter")
                v-text-field(style='float: right; margin-right: 19px; width: 30%;margin-top: 20px; margin-left: 10px;'
                  :placeholder="$t('table.enterWordOrDataForTheSearch')"
                  hide-details
                  filled
                  dense
                  :value='search'
                  @input='updateSearch'
                )
              template(slot='footer' slot-scope='{ pagination }')
                v-row(style='justify-content: flex-end;')
                  v-col(cols='auto')
                    label(for='pages') {{ $t('commonPhrases.perPage') }}
                    v-select(
                      dense
                      v-model='pagination.perPage'
                      item-text="item"
                      item-value="item"
                      :items="pagination.perPageOptions"
                    )
              template(slot='cells' slot-scope='{ item }')
                md-table-cell(:md-label='labels[0]') {{ formatLabels(item, 0) }}
                md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
                md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
                md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
                md-table-cell(:md-label='labels[4]' v-html='formatLabels(item, 4)')
                md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
                md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
                md-table-cell(:md-label='labels[7]') {{ formatLabels(item, 7) }}
  </template>
<script>
import * as moment from 'moment'
import debounce from 'lodash/debounce'
import Pagination from '@/components/Pagination.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    Pagination,
    DataTable,
    DataProvider
  },
  computed: {
    endpoint () {
      return this.mountUrlAndParams()
    }
  },
  props: {
    dialog: {
      type: Boolean
    },
    campaignId: {
      type: String
    },
    componentKey: {
      type: Number
    },
    selectedDate: {
      type: Object
    }
  },
  data () {
    return {
      responseData: [],
      teste: null,
      labels: [
        this.$t('campaign.triggeredAt'),
        this.$t('campaign.username'),
        this.$t('commonWords.channel'),
        this.$t('campaign.receiver'),
        this.$t('usersList.status'),
        this.$t('campaign.return'),
        this.$t('campaign.reading'),
        this.$t('campaign.conversationsStarted')
      ],
      filter: {
        order: 'desc',
        orderBy: 'sentAt',
        page: 0,
        perPage: 10,
        timezone: '-03:00'
      },
      search: ''
    }
  },
  methods: {
    mountUrlAndParams () {
      // const { from, to } = this.selectedDate
      // this.filter = { ...this.filter, to, from }
      return `${process.env.VUE_APP_BACKEND_BASE_URL}/campaign/${this.campaignId}/notification-status`
    },
    closeDialog () {
      if (this.filter !== '') {
        this.$set(this.filter, 'search', '')
      }
      this.$emit('update:dialog', false)
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item, 'sendAt')
        case 1:
          return item._source.username
        case 2:
          return item._source.channel
        case 3:
          return item.highlight ? item.highlight.contact[0] : item._source.contact
        case 4:
          return this.getStatus(item._source.status)
        case 5:
          return item._source.httpStatus || '-'
        case 6:
          return item._source.readAt ? this.formatDate(item, 'readAt') : '-'
        case 7:
          return item._source.conversationOfProactive !== undefined ? this.$t('commonWords.yes') : this.$t('commonWords.no')
        default:
          break
      }
    },
    formatDate (item, type) {
      let date = item._source[type]
      if (!date) return ''
      return moment(date).locale(selectedLocale).format('L LT')
    },
    getStatus (status) {
      switch (status) {
        case 'queued':
          return this.$t('campaign.statusSent')
        case 'delivered':
          return this.$t('campaign.statusDelivered')
        case 'sent':
          return this.$t('campaign.statusSent')
        case 'read':
          return this.$t('campaign.statusRead')
        case 'failed':
          return this.$t('campaign.statusFailed')
        default:
          return this.$t('commonWords.error')
      }
    },
    updateSearch: debounce(function (value) {
      let urlEncoded = encodeURIComponent(value)
      this.filter.search = urlEncoded
      this.$refs.dataProvider.load()
    }, 400),
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.listOfTriggeredTriggers'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      // let formattedDate1 = moment(this.selectedDate.from).locale(selectedLocale).format('L LTS')
      // let formattedDate2 = moment(this.selectedDate.to).locale(selectedLocale).format('L LTS')
      // doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total')
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    }
  },
  watch: {
    campaignId () {
      this.$nextTick(() => {
        if (this.$refs.dataProvider) {
          this.$refs.dataProvider.load()
        }
      })
    },
    componentKey () {
      this.$set(this.filter, 'page', 0)
      this.$set(this.filter, 'perPage', 5)
      if (this.$refs.dataProvider) {
        this.$refs.dataProvider.load()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  ::v-deep .md-table-head-label {
    font-size: 15px !important;
  }

  ::v-deep .md-card {
    box-shadow: none !important;
  }

</style>
